import { Controller } from "@hotwired/stimulus";

// Exclusive single-select "active" state across a group of children.
// Clicking any child wired with `data-action="click->active-group#select"`
// marks it active and clears `.active` from any siblings inside this
// controller's root. Useful for tabs, segmented controls, pill navs,
// category filters — any "one-of-N highlighted" pattern.
export default class extends Controller {
  select(event) {
    this.clear();
    event.currentTarget.classList.add("active");
  }

  clear() {
    this.element
      .querySelectorAll(".active")
      .forEach((el) => el.classList.remove("active"));
  }

  // Input-driven sync. Clears, then restores `[data-active-group-default]`
  // when the input is empty — so clearing a filter (× button, backspace)
  // falls back to the default option instead of a bare un-highlighted nav.
  reconcile(event) {
    this.clear();
    if (!event.target.value.trim()) {
      this.element
        .querySelector("[data-active-group-default]")
        ?.classList.add("active");
    }
  }
}
